import axios from 'axios'
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'
import { selectUser } from './user'
import { getReferrerId } from './referrer'

import API from '../config'
import { getHeaders } from './api'

const { apiPath, apiVersion } = API
const rootApi = `${apiPath}/${apiVersion}/`

export const LIKE_CARD = 'LIKE_CARD'
export const CARD_LIKED = 'CARD_LIKED'
export const UNLIKE_CARD = 'UNLIKE_CARD'
export const CARD_UNLIKED = 'CARD_UNLIKED'
export const VIEW_CARD = 'VIEW_CARD'
export const CARD_VIEWED = 'CARD_VIEWED'
export const SAVE_CARD = 'SAVE_CARD'
export const CARD_SAVED = 'CARD_SAVED'

export function likeCard(id, unlike = false, link) {
  return {
    type: LIKE_CARD,
    payload: { id, unlike, link }
  }
}

export function cardLiked(id, unlike = false, userId) {
  return {
    type: CARD_LIKED,
    payload: { id, unlike, userId }
  }
}

export function cardSaved(id, unsave = false, userId) {
  return {
    type: CARD_SAVED,
    payload: { id, unsave, userId }
  }
}

export function saveCard(id, unsave = false, link) {
  return {
    type: SAVE_CARD,
    payload: { id, unsave, link }
  }
}

export function viewCard(id) {
  return {
    type: VIEW_CARD,
    payload: { id }
  }
}

function cardViewed(id) {
  return {
    type: CARD_VIEWED,
    payload: { id }
  }
}

function* postLikeCard(action) {
  const user = yield select(selectUser)
  const { id, unlike, link } = action.payload
  let deck
  const token = user.data.auth_token
  let cardId

  try {
    if (!id) {
      deck = yield call(
        [axios, 'post'],
        `${rootApi}deck/schedule-link-extraction`,
        { url: link },
        {
          headers: getHeaders(token)
        }
      )
      cardId = deck.data.id
    }
    yield put(cardLiked(id || cardId, unlike, user.data.user.id))
    yield call(
      [axios, 'post'],
      `deck/${unlike ? 'unlike_card' : 'like_card'}`,
      {
        card_id: id || cardId
      },
      {
        baseURL: rootApi,
        headers: getHeaders(token)
      }
    )
  } catch (e) {
    yield put(cardLiked(id, !unlike, user.data.user_id))
  }
}

function* postSaveCard({ payload: { id, unsave, link } }) {
  const user = yield select(selectUser)
  const referrerId = yield select(getReferrerId)
  let deck
  const token = user.data.auth_token
  let cardId

  try {
    if (!id) {
      deck = yield call(
        [axios, 'post'],
        `${rootApi}deck/schedule-link-extraction`,
        { url: link },
        {
          headers: getHeaders(token)
        }
      )
      cardId = deck.data.id
    }
    yield put(cardSaved(id || cardId, unsave, user.data.user.id))
    yield call(
      [axios, 'post'],
      `account/${unsave ? 'unsave-card' : 'save-card'}`,
      {
        card_id: id || cardId,
        referrer_id: referrerId
      },
      {
        baseURL: rootApi,
        headers: getHeaders(user.data.auth_token)
      }
    )
  } catch (e) {
    yield put(cardSaved(id || cardId, !unsave, user.data.user.id))
  }
}

function* postViewCard(action) {
  const user = yield select(selectUser)
  const { id } = action.payload
  yield call(
    [axios, 'post'],
    'deck/view_card',
    {
      card_id: id
    },
    {
      baseURL: rootApi,
      headers: getHeaders(user.data.auth_token)
    }
  )
  yield put(cardViewed(id))
}

export function* cardActionsSaga() {
  yield takeLatest(LIKE_CARD, postLikeCard)
  yield takeEvery(VIEW_CARD, postViewCard)
  yield takeLatest(SAVE_CARD, postSaveCard)
}
